import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../Utils';

@Pipe({
    name: 'formatString'
})
export class FormatStringPipe implements PipeTransform {
    transform(value: string, replacements: any): any {
        return Utils.formatString(value, replacements);
    }
}